$(window).load(function() {
    eqHeights();
});

$(document).ready(function(){
    // Track event (for each step)?
    // trackEvent('page', 'change', $(incomingSlideEl).attr('id'));
        
    addRequiredAsteriskToLabels();
    $('.slide').each(function(){
        var bg = $(this).data('image');
        if (bg) {
            $(this).css("background", "url(" + bg + ")");
        }
    });
    $('.hero-image').each(function(){
        var hbg = $(this).data('background');
        $(this).css("background", "url(" + hbg + ")");
    });
    $('.mobile-nav-trigger').click(function(){
        $('.main-nav').css('height', 'auto');
    });
    
    // Pre-populate the fields from the mini box
    if ($.url().param('loan_state'))
        $('#state').val($.url().param('loan_state'));
    
    if ($.url().param('loan_amount')) {
        var param_amt = $.url().param('loan_amount');
        $('#loan_amount option:contains("' + param_amt + '")').prop('selected', true);
    }
    
    $('#salary, #joint_salary').on('keyup', function(e) {
        // Strip everything except numbers 
        var salary = $(this).val();
        if (salary == "") {
           $(this).next('span').html('Please enter a numerical value.');
        } else {
            if (isNaN(parseFloat(salary))) {
                $(this).next('span').html('Please enter only numbers.');
            } else {
                annual = Math.round((parseFloat(salary) * 12) * 100) / 100;
                $(this).next('span').html("( $" + annual.toLocaleString() + " annually )");
            }
        }
    });
    
    $('.joint-credit-input input[type=radio]').on('click', function(e) {
        if ($(this).val() == "Yes") {
            $('.joint-credit-conditional').show();
            $('.joint-credit-conditional input, .joint-credit-conditional select').attr('disabled', false);
        } else {
            $('.joint-credit-conditional').hide();
            $('.joint-credit-conditional input, .joint-credit-conditional select').attr('disabled', true);
        }
    });
     $('.joint-credit-conditional input, .joint-credit-conditional select').attr('disabled', true);
    
    $('.review-triangle').each(function () {
        var canvas = $(this);
        var context = canvas[0].getContext('2d');

        context.beginPath();
        context.lineTo(0, 0);
        context.lineTo(20, 0);
        context.lineTo(0, 20);

        context.closePath();
        context.shadowColor = "rgb(204,204,204)";
        context.shadowBlur = 5;
        context.shadowOffsetX = 0;
        context.shadowOffsetY = 2;
        context.fillStyle = "rgb(255,255,255)";
        context.fill();
    });
    
    $('.form-tooltip').tooltip();
    
    // Mask inputs on application summary page
    $("#ssn").mask("999-99-9999", {autoclear: false});
    $("#phone").mask("999-999-9999", {autoclear: false});
    $("#cell").mask("999-999-9999", {autoclear: false});
    $("#employer_phone").mask("999-999-9999", {autoclear: false});
    $("#joint_ssn").mask("999-99-9999", {autoclear: false});
    $("#joint_phone").mask("999-999-9999", {autoclear: false});

    // // Validate each step when the next button is pressed, before proceeding
    // $('.next').click(function(e) {
    //     e.preventDefault();
    //     var valid = true;
    //     $(this).closest('form').find('input, select, radio').each(function(i, input) {
    //         if (!$(input).valid()) {
    //             console.log("NOT VALID");
    //             console.log(input);
    //             valid = false;
    //         }
    //     });
    //     if (!valid) {
    //         e.stopImmediatePropagation();
    //         return;
    //     }
    // });
    
    function trackEvent(category, action, label, value) {
        
        if (typeof(ga) != "undefined")
            ga('send', 'event', category, action, label);
    }
    
    // Track events
    $('input[type="radio"]').change(function() { 
        var label = $(this).attr('name') + '-' + $(this).val();
        trackEvent('radio', 'select', label);
    });   
    
    $('a, button').click(function() {
        var label = $(this).attr('class');
        trackEvent('button', 'click', label);
    });
    
    // Get the current step number from the URL hash
    function current_step_from_hash(){
        var step = parseInt(location.hash.replace('#step', '')); 
        if (isNaN(step))
            return 1;
        else
            return step;
    }
    
    eqHeights();
    
    $('.amazing-map .datamaps-subunit').on('click touchstart', function() {
        if(typeof $(this).data('info') != 'undefined') {
            var info = $(this).data('info');
            var $stateDetails = $('.map-info[data-state=' + info.state + ']');
            $.fancybox($stateDetails.find('.map-info-fancybox'), {
                arrows: false,
                beforeShow : function(){
                    $('.fancybox-overlay').addClass('map-fancybox');
                    eqHeights();
                }
            });
        }
    });
    
    $('.map-btn.close').click(function() {
        $.fancybox.close();
    });
    
    $('.map-info-inceptybox').click(function() {
        newBox = $(this).data('fancybox');
        $.fancybox($(newBox), {
            arrows: false,
            beforeShow : function(){
                $('.fancybox-wrap').addClass('map-fancybox');
                eqHeights();
            }
        });
    });
    
    $('#review_form #tos_agree, #review_form #ela_agree').on('change', function(e) {
        if ($('#ela_agree').is(':checked') && $('#tos_agree').is(':checked')) {
            $('#review_form input.btn.next').removeClass('disabled').attr('disabled', false);
        }
    });
    $( '#full-circle-form input[type="submit"]' ).one('click', function() {
        $( ".submit-row" ).append( '<p style="margin-bottom: 0;">Submitting...</p>' );
    });
});

$(window).resize(function() {
    if($('#amazing-map').length) {
        map.resize();
    };            
});

var validator = $('#review_form').validate({
    rules: {
        tos_agree: {
            required: true
        },
        signature: {
            required: true
        }
    },
    messages: {
        tos_agree: {
            required: "agree to the terms and conditions"
        }
    },
    highlight: function(element) {
        $(element).closest('.form-row').removeClass('success').addClass('error');
    },
    errorPlacement: function(error, element) {
        $(element).closest('.form-row').append(error);
    },
    success: function(element) {
        $(element).closest('.form-row').removeClass('error').addClass('success');
    }
});

function eqHeights() {

    if ($(window).width() > 768) {

        $('.same-height-row').each(function () {
            var elements = $(this).find('.height');
            var height = 0;
            elements.css('min-height', '0');
            elements.each(function () {
                height = $(this).outerHeight() > height ? $(this).outerHeight() : height;
            });
            elements.css('min-height', height + 'px');
        });

        var height = 0;
        $('.same-height').each(function () {
            $(this).css('min-height', '0');
            height = $(this).outerHeight() > height ? $(this).outerHeight() : height;
        }).css('min-height', height + 'px');

        $('.height.exact').each(function () {
            $(this).css('height', $(this).css('min-height'));
        });

    } else {

        $('.same-height, .height').css({
            'height': 'initial',
            'min-height': '0'
        });

    };

};

$(window).resize(function () {
    eqHeights();
});

// Amazing Loan Box
function get_field_data(name) {
    return $('input[name="' + name + '"],select[name="' + name + '"]').find('option:selected').data();
}
function get_field(name) {
    return $('input[name="' + name + '"],select[name="' + name + '"]').val();
}
function set_field(name, value) {
    return $('input[name="' + name + '"],select[name="' + name + '"]').val("").val(value); // Value reset to "" first for weird Chrome issue
}

// Disable weekly payment and length of loan fields
$('input[name="weekly_payment"], input[name="loan_length"]').focus(function() { $(this).blur() });

// Initially disable loan amount field
$('#loan_amount').prop('disabled', true);

// This disables / enables the available loan amounts for the selected state
function get_loan_amounts(state) {
    $.get('/api/v2/loan-amounts?code=' + state, {}, function(loan_amounts) {
        
        $('#loan_amount option').each(function(i, v) {
            var opt_val = $(v).val();
            // Skip the 'Loan Amount' first option
            if (opt_val != '') {
                if ($.inArray(opt_val, loan_amounts) != -1) {
                    $(v).prop('disabled', false);   
                } else {
                    $(v).prop('disabled', true);   
                }
            }
        });

        // If the selected amount isn't offered in this state, reset to the blank 'Loan Amount' option
        var selected = $('select[name="loan_amount"] option:selected');
        if (selected.length && selected.val() != '' && selected.prop('disabled')) {
            set_field('loan_amount', '');
            set_field('weekly_payment', '');
            set_field('loan_length', '');
            $('.loan-box input').removeClass('valid');
        }
    });
}

function get_loan_data(amount, state) {
    $.get('/api/v1/calculator', { state: state, loan: amount }, function(loan_data) {
        // Ignore a response for an amount or state that has since changed
        if (get_field('loan_amount') != amount || get_field('loan_state') != state) {
            return;
        }
        if (loan_data) {
            var term_fixed = loan_data['term_fixed'];
            var fixed_payment = $.trim(loan_data['weekly_fixed_payment']);
            var monthly = loan_data['only_monthly'];
            var payment = Math.ceil(fixed_payment.replace(/[^\d\.\,]/, ''));
            
            if (!monthly) {
                set_field('weekly_payment', '$' + payment);
                set_field('loan_length', loan_data['term_fixed'] + " weeks");
                $('span.payment_term').text('Weekly');
            } else {
                set_field('weekly_payment', '$' + payment);
                set_field('loan_length', loan_data['term_fixed'] + " months");
                $('span.payment_term').text('Monthly');
            }
            $('.loan-box input').addClass('valid');
            // set_summary_field('payment_terms', loan_data['term_fixed'] + " weeks");
        }
    });
}

$('.loan-box input, .loan-box select').change(function() {
    $('.loan-box input').removeClass('valid');
    // Make sure multiple forms match
    set_field($(this).attr('name'), $(this).val());

    var loan_amount = get_field('loan_amount');
    var state = get_field('loan_state');
    
    if (state) {
        $('#loan_amount').prop('disabled', false);
        get_loan_amounts(state);
    }
    
    if (loan_amount && state) {
        get_loan_data(loan_amount, state);
    }
});

function _log(str) {
    if (typeof console != "undefined")
        console.log(str);
}

$.validator.addMethod('social_security_number', function(value) {
    return /^\d\d\d-\d\d-\d\d\d\d$/.test(value);
}, "Please enter a valid social security number.");

$.validator.addMethod('no_numbers', function(value) {
	return /^\D*$/.test(value);
}, "Please do not enter any numbers.");

// Give Georgia different Options
// var prev_select;
// $('select[name="loan_state"]').on('focus', function() {
//     prev_select = this.value;
// }).change(function() {
//     set_field('state', get_field('loan_state'));
//     $('select[name="loan_amount"]').val('Loan Amount');
//     set_field('weekly_payment', '$0');
//     set_field('loan_length', '0 mos');
//     prev_select = this.value;
// });

// Application
// Make part of the page conditional on the value of a form field
function conditional_field(selection_field_name, dependent_selector) {
    $(dependent_selector).hide();
    $('input[name="' + selection_field_name + '"]').change(function() {
        if ($('input[name="' + selection_field_name + '"]:checked').val() == 'Yes') {
            $(dependent_selector).show();
            $(dependent_selector).find('input, select').attr('disabled', false);
        } else {
            $(dependent_selector).hide();
            $(dependent_selector).find('input, select').attr('disabled', true);
        }
        
    });
}

// Returns a function that returns whether field is checked
function field_checked(field) {
    return function() {
        return $('input[name="' + field + '"]:checked').val() == 'Yes';
    }
}

// Return true if the given state is a community property state
function state_is_community_property(state) {
    return (state == 'Nevada' || state == 'Arizona');
}

conditional_field('joint_unsecured', '#marital-status');
conditional_field('joint_unsecured', '#marital-status-review-row')
conditional_field('alimony', '#other-income-box');
conditional_field('joint_joint_unsecured', '#joint-marital-status');
conditional_field('joint_joint_unsecured', '#joint-marital-status-review-row');
conditional_field('joint_alimony', '#joint-other-income-box');
    
    
// Validation
var required_if_jointcredit = {
    required: {
        depends: field_checked('jointcredit')
    }
};
var number_if_jointcredit = {
    number: {
        depends: field_checked('jointcredit')
    }
};
function _if_joint_credit(type) {
    var r = {};
    r[type] = {
        depends: field_checked('jointcredit')
    }
    return r;
}
$(document).ready(function() {
    var step_one_validator = $('#prequalification_form').validate({
        rules: {
            first_name: { 
                required: true,
                no_numbers: true
            },
            last_name: {
                required: true,
                no_numbers: true
            },
            email: {
                required: true
            },
            confirm_email: {
                equalTo: '#email',
                required: true
            },
            address: {
                required: true
            },
            city: {
                required: true,
                no_numbers: true
            },
            state: {
                required: true
            },
            zip: {
                required: true,
                number: true,
                maxlength: 5,
                minlength: 5
            },
            phone: {
                required: true,
                phoneUS: true
            },
            birthdate: {
                date: true
            },
            ssn: {
                required: true,
                social_security_number: true
            },
            loan_amount: {
                required: true
            },
            purpose: {
                required: true
            }
        },
        errorPlacement: function(error, element) {
            $(element).closest('.form-row').append(error);
            $(element).closest('.form-row').removeClass('success').addClass('error');
        },
        success: function(element) {
            $(element).closest('.form-row').removeClass('error').addClass('success');
        },
        submitHandler: function(form) {
            $('#app1-modal').modal('show');
            var destination;
            var xhr = $.post($(form).attr('action'), $(form).serialize(), function(data) {
                if (data["prequalified"] == true) {
                    // DEV URL
                    //destination = "https://mramazingloans.equisolve-dev.com/apply-now/step-two";
                    destination = "https://www.mramazingloans.com/apply-now/step-two";
                } else {
                    if (data["reason"] == "duplicate") {
                        // DEV URL
                        //destination = "https://mramazingloans.equisolve-dev.com/apply-now/youve-already-applied";
                        destination = "https://www.mramazingloans.com/apply-now/youve-already-applied";
                    } else {
                        // DEV URL
                        //destination = "https://mramazingloans.equisolve-dev.com/apply-now/step-one/rejection";
                        destination = "https://www.mramazingloans.com/apply-now/step-one/rejection";
                    }
                }
                //console.log(destination);
                window.location.href = destination;
            }, "json").fail(function() {
                // DEV URL
                //window.location.href = "https://mramazingloans.equisolve-dev.com/apply-now/sorry";
                window.location.href = "https://www.mramazingloans.com/apply-now/sorry";
            });
        }
    });
});
// Adds asterisk to the labels of required form inputs
function addRequiredAsteriskToLabels() {
    $("form .required").siblings("label").each(function () {
        var currentText = $(this).text();
        $(this).text(currentText + "*");
    });
}